'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getGlobal() {
  if (typeof window !== 'undefined') {
    return window;
  }
  /* eslint-disable no-restricted-globals */


  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  return {};
}
var g = getGlobal();

exports['default'] = getGlobal;
exports.g = g;
